import React from "react";
import {Button, ButtonType} from "@reapptor-apps/reapptor-react-components";
import CruiseWizardPage from "@/pages/Cruise/CruiseWizardPage";
import Localizer from "@/localization/Localizer";

import styles from "./Start.module.scss";

export interface IStartProps {
}

interface IStartState {
}

export default class Start extends CruiseWizardPage<IStartProps, IStartState> {

    state: IStartState = {
    };

    public async actionAsync(call: boolean = false): Promise<void> {
        this.wizard.call = call;
        this.saveContext();
        await super.nextAsync();
    }

    public renderContent(): React.ReactNode {
        return (
            <div className={styles.start}>
                <Button block type={ButtonType.Dark} label={Localizer.cruiseWizardStart} onClick={() => this.actionAsync()} />

                <Button block type={ButtonType.Light} label={Localizer.cruiseWizardCall} onClick={() => this.actionAsync(true)} />
            </div>
        );
    }
}